<script>
import UploadCsv from './UploadCsv.vue';
import AddedSuggestedKeywords from './AddedSuggestedKeywords.vue';
import { toRaw } from 'vue';
import { isEmpty } from 'lodash';
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import {algoliaClient, algoliaIndex, getProducts } from "../../AlgoliaSDK";
import { ALGOLIA_APP_ID, ALGOLIA_API_KEY, ALGOLIA_INDEX_NAME, ENABLE_PHRASE } from "../env"
import { getCookie,getQueryParam, getKeywordSuggestions, getLoggedSellerId } from '@/services/campaignService';

var getAddedProductIds = function(adGroups, ind) {
    var adGroup = adGroups[ind];
    var adGroupProductIds = new Array(adGroup.productList?.length);
    for (var i = 0; i < adGroup.productList?.length; i++) {
        adGroupProductIds[i] = adGroup.productList[i];
    }
    return adGroupProductIds;
}

var getAddedCategories = function(adGroups, ind) {
    var adGroup = adGroups[ind];
    if (adGroup?.targetValues?.length <= 0) {
        return [];
    }
    var adGroupCategories = new Array(adGroup.targetValues?.length);
    for (var i = 0; i < adGroup.targetValues?.length; i++) {
        adGroupCategories[i] = {
            bid_price : adGroup.targetValues[i]?.bid_price,
            match_type : adGroup.targetValues[i]?.match_type === 'Exact' ? 1
                : adGroup.targetValues[i]?.match_type === 'Phrase' ? 0
                : adGroup.targetValues[i]?.match_type === 'Broad' ? 2 : null,
            keyword : adGroup.targetValues[i]?.keyword,
        };
    }
    return adGroupCategories;
}

export default {
    name: 'ProductSelection',
    data(){
        return {
            list: [],
            counter: 0,
            showUploadComponent: false,
            activeTab: this.targeting ? 'enterList' : 'search',
            product: null, 
            category: this.enteredKeyword ?? null,
            selectedProducts: this.addGroupList?.length && this.addGroupList[this.count] ? this.addGroupList?.[this.count]?.products : [],
            addedProducts: toRaw(this.campaignData)?.adGroups?.length > 0 ? getAddedProductIds(toRaw(this.campaignData)?.adGroups, 0) : [],
            addedCategories:toRaw(this.campaignData)?.adGroups?.length > 0 ? getAddedCategories(toRaw(this.campaignData)?.adGroups, 0) : this.addGroupList?.length ? this.addGroupList?.[this.count]?.keywords : [],
            search: null,
            targetSearch: null,
            productSearchResult: this.addGroupList?.length && this.addGroupList[this.count] ? this.addGroupList?.[this.count]?.searchedProducts : [],
            productSearchStatus: null,
            productCheckbox: false,
            selectedProductIds:[],
            productIds: [],
            keywordsArrayFromCsv:[],
            sellerId: '',
            skipSellerCheck: false,
            emptyMessage: 'Add product id for ad group',
            selectAllClicked: false,
            removeAllClicked: false,
            targetingType: this.campaignData.isPDP ? "Product" : this.campaignData?.ad_format_type === 1 ? "Keyword" : "Category",
            matchTypes: [
                { title: "Exact" },
            ],
            url: 'https://www.jiomart.com/images/product/original/',
            isDisabled: this.isdisabled,
            showSuggestedKeywords: true,
            suggestedKeywords: this.addGroupList?.length && this.addGroupList[this.count] ? this.addGroupList?.[this.count]?.suggestions ?? [] : [],
            match_type: this.addedCategories?.length ? this.addedCategories[0].match_type ? 'Exact' : this.addedCategories[0].match_type === 2 ? 'Broad' : 'Phrase' : this.addGroupList?.[this.count]?.keywordMatch?.type ?? 'Exact',
            bid: this.addedCategories?.length && (this.addedCategories[0].match_type === 0 || this.addedCategories[0].match_type === 2) ? this.addedCategories[0].bid_price : this.addGroupList?.[this.count]?.keywordMatch?.bid ?? null,
            addedSuggestedKeywords:[],
            suggestedMatchTypes: [],
            suggestedBidPrices: [],
            loading: false,
            loadingForUpload: false,
            enablePhrase: ENABLE_PHRASE === 'true',
            role: getCookie('role')
        }
    },
    mounted() {
        this.sellerId = getLoggedSellerId();
        this.addedCategories = toRaw(this.campaignData)?.adGroups?.length > 0 ? getAddedCategories(toRaw(this.campaignData)?.adGroups, 0) : this.addGroupList?.length ? this.addGroupList?.[this.count]?.keywords : [];
        this.match_type = this.addedCategories?.length ? this.addedCategories[0].match_type === 1 ? 'Exact' : this.addedCategories[0].match_type === 2 ? 'Broad' : 'Phrase' : this.addGroupList?.[this.count]?.keywordMatch?.type ?? 'Exact';
        this.bid = this.addedCategories?.length && (this.addedCategories[0].match_type === 0 || this.addedCategories[0].match_type === 2) ? this.addedCategories[0].bid_price : this.addGroupList?.[this.count]?.keywordMatch?.bid ?? null;
        this.category = this.enteredKeyword ?? null;
        this.productSearchResult = this.addGroupList?.length && this.addGroupList[this.count] ? this.addGroupList?.[this.count]?.searchedProducts : [];
        this.selectedProducts = this.addGroupList?.length && this.addGroupList[this.count] ? this.addGroupList?.[this.count]?.products : []
        this.suggestedKeywords = this.addGroupList?.length && this.addGroupList[this.count] ? this.addGroupList?.[this.count]?.suggestions : []
    },
    props: {
        targeting: Boolean,
        title: String,
        clearForm: Boolean,
        clearTargeting: Boolean,
        campaignData: Object,
        products: Array,
        keywords: Array,
        sellerIdRole: String,
        count: Number,
        isdisabled: Boolean,
        selectionType: String,
        showViewSuggestionsBtn: Boolean,
        updatedSelectedProducts: Array 
    },
    computed: {
        ...mapState(['addedKeywords','addGroupList', 'enteredKeyword', 'campaignClass']),
        resultQuery(){
            if(this.keywordsArrayFromCsv.length > 0){
                return this.keywordsArrayFromCsv
            }
            if(!isEmpty(this.keywords)){
                if(this.targetSearch){
                    const filteredItems = this.addedCategories.filter((item)=>{
                        return item.keyword.toLowerCase().includes(this.targetSearch.toLowerCase())
                    })
                    return filteredItems;
                }else{
                    return this.keywords;
                }
            }
            if(this.search){
                return this.addedProducts.filter((item)=>{
                    const productId = item.productId.toString();
                    
                    return !isNaN(productId) && productId.toLowerCase().includes(this.search.toLowerCase())
                })
            }
            if(this.targetSearch){
                return this.addedCategories.filter((item)=>{
                    return item.keyword.toLowerCase().includes(this.targetSearch.toLowerCase())
                })
            }
            return 
        },
        filteredSuggestions() {
            const filteredItems = this.suggestedKeywords.filter((item) => 
                !this.addedCategories.some(addedCategory => 
                    addedCategory.keyword.toLowerCase() === item.keyWord.toLowerCase()
                )
            );
            if(this.targetSearch) {
                return filteredItems
                    .filter(item => item.keyWord.toLowerCase().includes(this.targetSearch.toLowerCase()));
            }
            return filteredItems;
        }
    },
    watch: {
        clearForm(newValue, OldValue){
            if(newValue){
                this.onFormclear();
            }
        },
        title(newTitle, oldTitle){
            if(newTitle !== oldTitle)
                this.onFormclear();
        },
        addedCategories(newValue, OldValue){
            this.addedCategories = toRaw(newValue);
        },
        addedProducts(newProducts, OldProducts){
            this.addedProducts = toRaw(newProducts);
        },
        selectedProducts(newVal, oldVal){
            this.$emit('productsAdded', this.selectedProducts, this.productSearchResult, this.addGroupList?.[this.count]?.isOpen)
        },
        keywordsArrayFromCsv(newVal, oldVal){
            const updatedData = this.keywordsArrayFromCsv.map(item => {
                if(item.match_type === 'Exact'){
                    return {
                        ...item,
                        match_type: 1,
                    };
                } else if (item.match_type === 'Phrase') {
                    return {
                        ...item,
                        match_type: 0
                    }
                }
                return item;
            })
            this.addedCategories = [...this.addedCategories, ... updatedData]
            this.$emit('categoriesAdded', [...this.addedCategories])
        },
        bid(newVal, oldVal){
           if(this.campaignClass !== 'Privilege') {this.onDailyBudgetChange();}
        },
        category(newVal, oldVal) {
            if(this.match_type === 'Phrase') {
                this.setEnteredKeyword(newVal);
            }
        }
    },
    methods: {
        ...mapMutations(['setAddedKeywords']),
        ...mapActions(['setEnteredKeyword']),
        handleBid(event) {
            const value = Number(event.target.value);
            if(this.match_type !== 'Exact') {
                this.addedCategories = this.addedCategories.map((item) => {
                    const obj = {...item, bid_price: value};
                    return obj;
                });
                this.$emit('categoriesAdded', this.addedCategories, this.suggestedKeywords, {type: this.match_type, bid: value})
            }
        },
        handleMatch(event) {
            const value = event.target.value;
            this.addedCategories = this.addedCategories.map((item) => {
                const obj = {
                    ...item, 
                    match_type: value === 'Exact' ? 1 : value === 'Broad' ? 2 : 0,
                    bid_price: value === 'Exact' ? item.bid_price : this.addedCategories[0].bid_price
                };
                return obj;
            });
            this.$emit('categoriesAdded', this.addedCategories, this.suggestedKeywords, {type: value, bid: this.campaignClass === 'Privilege' ? this.campaignData.cpm : value === 'Exact' ? null : this.addedCategories[0]?.bid_price ?? null})
        },
        onDailyBudgetChange(){
            
            const totalBudget = this.campaignData?.budget_total_limit;
            const dailyBudget = this.campaignData?.budget_daily_limit;
            
            if(dailyBudget != -1 && dailyBudget < this.bid){
                this.budgetErrorMEssage = "Bid price cannot be greater than Daily budget"
            }else if(totalBudget && this.bid && (totalBudget < this.bid)){
                this.budgetErrorMEssage = "Bid cannot be greater than total budget"
            }else{
                this.budgetErrorMEssage = null
            }
        },
        restrictInput(){
            const regexPattern = /^[a-zA-Z0-9\s-]*$/;

            if (!regexPattern.test(this.category)) {
                this.category = this.category.replace(/[^a-zA-Z0-9\s-]/g, '');
            }
        },
        onSelectAllProductsClick(){
            this.selectAllClicked = true;
            this.removeAllClicked = false;
            this.selectedProducts = this.productSearchResult;
        },
        onRemoveAllProductsClick(){
            this.removeAllClicked = true;
            this.selectAllClicked = false;
            this.selectedProducts = [];
        },
        deleteFromList(index, targeting) {
            if(targeting){
                if(this.keywordsArrayFromCsv?.length>0){
                    this.keywordsArrayFromCsv.splice(index, 1);
                    this.$emit('categoriesAdded', this.keywordsArrayFromCsv)
                }else{
                    this.addedCategories?.splice(index, 1);
                    this.$emit('categoriesAdded', this.addedCategories)
                }
            }else{
                this.addedProducts.splice(index, 1);
                this.$emit('productsAdded', this.addedProducts, this.productSearchResult,this.addGroupList?.[this.count]?.isOpen)
            }
        },
        deleteFromAddedSuggestionsList(index){
            this.addedSuggestedKeywords?.splice(index, 1);
            this.addedCategories?.splice(index, 1);
            this.$emit('categoriesAdded', this.addedCategories)
        },
        deleteAllSelectedKeywords(){
            this.addedSuggestedKeywords=[];
            this.addedCategories=[];
            this.$emit('categoriesAdded', this.addedCategories)
        },

        onFormclear(){
            // if(this.clearTargeting){
                this.addedCategories = [];
            // }
            this.deleteAll();
            this.addedProducts = [];
            this.addedCategories = [];
        },

        deleteAll(){
            this.addedProducts=[];
            this.$emit('productsAdded', this.addedProducts, this.productSearchResult,this.addGroupList?.[this.count]?.isOpen)
        },

        onFileUpload(){
            this.$emit('clearErrorMessage')
        },

        // onAddAllSuggestedKeywords(){
        //     this.addedCategories?.unshift(this.suggestedKeywords);
        // },

        addItem(value) {
            console.log(value, 'asfd')
            if(value?.keyword && value?.match_type && value?.bid){
                let categories = {
                    keyword: value.keyword,
                    match_type: value.match_type === 'Exact' ? 1 : value.match_type === 'Phrase' ? 0
                        : adGroup.targetValues[i]?.match_type === 'Broad' ? 2 : null,
                    bid_price: value.bid
                }
                this.addedSuggestedKeywords.push(categories)
                let obj = {
                    count: this.count,
                    addedKeywords: this.addedSuggestedKeywords
                }
                if(this.addedSuggestedKeywords.length>0){
                    this.setAddedKeywords(obj)
                    this.addedCategories = [...this.addedCategories, ...this.addedSuggestedKeywords]
                    this.$emit('categoriesAdded', this.addedCategories, this.suggestedKeywords)
                }
                // this.category = value.category;
            }
            if(this.product){
                if(!this.addedProducts.some(el => el.productId === this.product) && !isNaN(this.product)){
                    let products = {
                        productId: this.product
                    }
                    this.addedProducts.push(products)
                    this.$emit('productsAdded', this.addedProducts, this.productSearchResult,this.addGroupList?.[this.count]?.isOpen)
                }
            }else if(this.category && this.match_type && (this.bid || this.campaignClass === 'Privilege')){
                let categories = {
                    keyword: this.category,
                    match_type: this.match_type === 'Exact' ? 1 : this.match_type === 'Phrase' ? 0 : null,
                    bid_price: this.campaignClass === 'Privilege' ? this.campaignData.cpm : parseFloat(this.bid.toFixed(2))
                }
                this.setEnteredKeyword(null);
                const keywordExists = this.addedCategories?.some(el => el.keyword?.toLowerCase() === this.category?.toLowerCase());
                if(this.keywordsArrayFromCsv.length>0){
                    this.keywordsArrayFromCsv.unshift(categories);
                    this.$emit('categoriesAdded', this.keywordsArrayFromCsv)
                }else if(!keywordExists){
                    this.addedCategories?.unshift(categories);
                    this.$emit('categoriesAdded', this.addedCategories)
                } else {
                    this.addedCategories = this.addedCategories.map(addedCategory => addedCategory.keyword === this.category ? 
                        {
                            ...addedCategory,
                            match_type: this.match_type === 'Exact' ? 1 : this.match_type === 'Phrase' ? 0 : null,
                            bid_price: this.campaignClass === 'Privilege' ? this.campaignData.cpm : this.bid
                        } : 
                        addedCategory
                    );
                    this.$emit('categoriesAdded', this.addedCategories)
                }
            }
            this.product=this.category=this.bid='';
            this.match_type=null;
        },

        onUploadClick () {
          this.showUploadComponent = true;
          this.showSuggestedKeywords = false;
        },
        onListClick () {
          this.showSuggestedKeywords = false;
          this.showUploadComponent = false
          this.emptyMessage = 'Add product id for ad group'
        },
        onSuggestedTabClick(){
            this.showSuggestedKeywords = true;
            this.showUploadComponent = false;
        },
        removeSelection(item,disabled){
            if(!disabled) {
                let list2 = [...this.selectedProducts];
                let indexToRemove = this.selectedProducts.findIndex(obj => obj.productId === item.productId)
                if(indexToRemove !== -1){
                    list2.splice(indexToRemove, 1)
                }
                this.$emit('productsAdded', list2, this.productSearchResult, this.addGroupList?.[this.count]?.isOpen)
                this.selectedProducts = list2;
            }
        },
        async onSearchBtnClick(source, targetingType){
            // this.skipSellerCheck = this.sellerIdRole === 'SELLER' ? false : true;
            if(targetingType === 'products' || this.productIds?.length > 0){
                // if(this.productIds.length > 0){
                    try {
                        let algoliaclient = await algoliaClient(ALGOLIA_APP_ID, ALGOLIA_API_KEY);
    
                        let algoliaindex = await algoliaIndex(algoliaclient, ALGOLIA_INDEX_NAME);
                        let products; 
                        if(source === 'csv'){
                            this.productSearchResult=[]
                            this.onRemoveAllProductsClick();
                            this.search = null;
                            products = await getProducts(algoliaindex, toRaw(this.productIds), this.sellerId, this.skipSellerCheck, this.sellerIdRole);
                            this.loadingForUpload = false;
                        }else{
                            if(!isNaN(this.search) && !this.productSearchResult.some(el => el.productId === this.search)){
                                if(this.search){
                                    this.loading = true;
                                }
                                products = await getProducts(algoliaindex, [this.search.trim()], this.sellerId, this.skipSellerCheck, this.sellerIdRole);
                                this.loading = false;
                            }else{
                                this.search = null;
                                return
                            }
                        }

                        let test = Array.from(products, ([key, value]) => (value))

                        let productsArray = test.map(product => {
                            return product.get('data')
                        })
    
                        // this.productSearchResult = test.map(product => product.get('data'));
                        if(test?.length === 1){
                            test.map(product => {
                                let hasCategory = true;
                                if(this.targetingType !== 'Keyword') {
                                    const categoryLevel = product.get('data')?.categoryLevel;
                                    hasCategory = categoryLevel && Object.values(categoryLevel).length;
                                    if(hasCategory) {
                                        if(this.targetingType == 'Product') {
                                            hasCategory = hasCategory && Object.values(categoryLevel).every(item => item?.length);
                                        } else {
                                            const {level4, ...levels} = categoryLevel;
                                            hasCategory = hasCategory && Object.values(levels).every(item => item?.length);
                                        }
                                    }
                                }
                            if((product.get('statusCode') === 0) && hasCategory){
                                this.productSearchResult?.push(product.get('data'))
                            }else{
                                // this.productSearchResult = []
                                this.emptyMessage = 'No valid products found'
                            }
                        })}else{
                            test.map(product => {
                                let hasCategory = true;
                                if(this.targetingType !== 'Keyword') {
                                    const categoryLevel = product.get('data')?.categoryLevel;
                                    hasCategory = categoryLevel && Object.values(categoryLevel).length;
                                    if(hasCategory) {
                                        if(this.targetingType == 'Product') {
                                            hasCategory = hasCategory && Object.values(categoryLevel).every(item => item?.length);
                                        } else {
                                            const {level4, ...levels} = categoryLevel;
                                            hasCategory = hasCategory && Object.values(levels).every(item => item?.length);
                                        }
                                    }
                                }
                                if((product.get('statusCode') === 0) && hasCategory){
                                    this.productSearchResult?.push(product.get('data'))
                                }else{
                                    this.emptyMessage = 'No valid products found'
                                }
                            })
                        }

                        this.showUploadComponent = false
    
                    }catch(e){
                        console.log("error in getting hits: ", e)
                    } 
                // }
            }else if(this.keywordsArrayFromCsv?.length > 0){
                    this.showUploadComponent = false
                    // this.resultQuery();
            }
            
        },
        getProductIDArray(value){
            if(this.targeting && value?.length > 0){
                this.$emit('invalidCsvUploaded')
            }else if(value?.length > 50){
                this.productIds=value.slice(0, 50);
                this.$emit('CsvUploadLimitExceeded',true)
            }else{
             this.productIds=value;
            }
        },
        getKeywordArray(value){
            if(!this.targeting && value?.length > 0){
                this.$emit('invalidCsvUploaded')
            }
            this.keywordsArrayFromCsv = value?.slice(1).map(item => {
                return {...item, match_type: this.match_type, bid_price: this.campaignClass === 'Privilege' ? this.campaignData.cpm : this.match_type === 'Exact' ? item.bid_price : this.bid ?? value?.[1].bid_price}
            });
        },
        onViewSuggestionsClick(){
            getKeywordSuggestions({'products': this.updatedSelectedProducts})
            .then(res=>res.json())
            .then(data => {
                this.suggestedKeywords = data.map(item => {return {...item, selected: 'Exact'}});
                this.$emit('categoriesAdded', this.addedCategories, this.suggestedKeywords)
                if(this.suggestedKeywords.length>0){
                    this.showSuggestedKeywords = true;
                }
            })
        },
        onUpdateLoader(value){
            this.loadingForUpload = value;
        },
        // bid: {
        //     handler: 'onDailyBudgetChange',
        //     immediate: true,
        //     deep: true,
        // },
        transformArray(inputValues) {
            let transformedArray = [
                    {
                        "Keyword": "Keyword",
                        // "Match type": "Match type",
                        "Bid": "Bid"
                    },
                    ...inputValues?.map(item => ({
                    "Keyword": item.keyWord,
                    // "Match type": item.selected,
                    "Bid": item.bid_price_suggestion
                }))
            ]
            return transformedArray
        },
        downloadCSV() {
            const csvContent = "data:text/csv;charset=utf-8," +
            this.transformArray(this.suggestedKeywords)?.map(row => Object.values(row).join(',')).join('\n');

            const link = document.createElement('a');
            link.href = encodeURI(csvContent);
            link.target = '_blank';
            link.download = 'data.csv';

            link.click();
        },
    },
    components: {
        UploadCsv,
        AddedSuggestedKeywords,
    }
}
</script>

<template>
    <div>
        <div v-if="targeting">
            <div class="heading"> Keyword Match Type </div>
            <div class="checkboxClass" style="margin-top: 16px; margin-bottom: 16px">
                <input id="Exact" type="radio" value="Exact" v-model="match_type" v-on:change="handleMatch">
                <label style="margin-right: 170px;">Exact</label>

                <input id="Phrase" :disabled="!enablePhrase" type="radio" value="Phrase" v-model="match_type" v-on:change="handleMatch">
                <label style="margin-right: 170px;">Phrase</label>

                <input :disabled="!(role === 'OPS' || role === 'SUPERADMIN')" id="Broad" type="radio" value="Broad" v-model="match_type" v-on:change="handleMatch">
                <label style="margin-right: 170px;">Broad</label>
            </div>
                <div v-if="match_type !== 'Exact' && campaignClass !== 'Privilege'" style="margin: 16px 16px 16px 0px;"> 
                    <div class="heading" style="margin-bottom: 12px">{{match_type === 'Phrase' ? "Phrase" : "Broad"}} Bid Price</div>
                    <div style="display: flex"> 
                        <img style="padding: 12px; background: #F2F2F2" src="../assets/currencyIcon.svg"> <input v-model="bid" :disabled="this.isDisabled" class="textbox" type="number" min="0" name="bid" placeholder="Bid price" v-on:change="handleBid" />
                    </div>
                </div>
        </div>
        <div class="wrapper"> 
            <div v-if="selectionType === 'products' || (selectionType === 'keywords' && match_type !== 'Broad')" class="productSelection"> 
                <div class="headingWrapper"> 
                    <div v-if="targeting" class="heading required">
                        {{ title }} Selection
                    </div>
                    <div v-else class="heading required">Product Selection</div>
                    <div v-if="selectionType === 'keywords' && showSuggestedKeywords && match_type === 'Exact'" @click="onViewSuggestionsClick" class="refresh"><img alt="refresh" class="refreshIcon" src="../assets/refreshIcon.svg"/> Refresh Suggestions</div>

                </div>

                <div class="table">
                    <div class="firstRow"> 
                        <div v-bind:class="{'activeClass': showSuggestedKeywords}" v-if="targeting" @click="onSuggestedTabClick" class="row">Suggested</div>
                        <div v-bind:class="{'activeClass': !showUploadComponent && !showSuggestedKeywords}" v-if="!targeting" @click="onListClick" class="row">Enter list</div>
                        <div v-bind:class="{'activeClass': showUploadComponent}" @click="onUploadClick" class="row">Upload</div>
                    </div>
                    <!-- Keywords -->
                    <!-- add products and keywords manually  -->
                    <div v-if="(targeting && !showUploadComponent)"> 
                        <div class="secondRow"> 
                            <div class="search"> 
                                <img alt="img" class="searchIcon" src="../assets/SearchIcon.svg"/>
                                <input :disabled="this.isDisabled" class="searchClass" v-model="targetSearch" type="text" v-bind:placeholder="`Search ${title}`">
                                <div class="searchText"></div>
                            </div>
                            <img v-if="showSuggestedKeywords && suggestedKeywords?.length>0" @click="downloadCSV" style="cursor: pointer" v-b-tooltip title="Download CSV" src="../assets/downloadIconAnalytics.svg" alt="download">
                        </div>
                        <table v-if="showSuggestedKeywords" class="suggestedKeywords"> 
                            <thead class="suggested"> 
                                <th  class="tableRow"> 
                                    <tr class="text">Keyword</tr>
                                    <tr style="margin-left: 100px" class="text" >Match type</tr>
                                    <tr :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" class="text" style="margin-left: 29px;">Suggested Bid</tr>
                                    <tr :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" style="margin-left: 24px;" class="text">Your Bid</tr>
                                    <tr></tr>
                                    <!-- <tr class="add" v-if="suggestedKeywords.length>0" @click="onAddAllSuggestedKeywords">Add all</tr> -->
                                </th>
                            </thead>

                            <tbody> 
                            <div class="fourthRow"> 
                                <input :disabled="this.isDisabled" @input="restrictInput" class="searchText categorySearch" name="searchText" v-model="category" v-bind:placeholder="`Enter ${title}`">

                                <select :disabled="this.isDisabled" class="match_type" v-model="match_type">
                                    <option disabled :value="null" >Type</option>
                                    <option v-if="!title.includes('Keyword')">NA</option>
                                    <option :disabled="match_type === 'Phrase'" v-if="title.includes('Keyword')">Exact</option>
                                    <option :disabled="match_type === 'Exact'" v-if="title.includes('Keyword')">Phrase</option>
                                </select>
                                <div :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" class="productId categoryClass" style="min-width: 70px;max-width: 70px;text-align: left;padding-left: 15px;">NA</div>

                                <div :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" class="content" style="margin-left: 8px; margin-right: 4px"> 
                                    <img alt="img" class="currencyIcon" src="../assets/currencyIcon.svg"> <input v-model="bid" :disabled="this.isDisabled || match_type === 'Phrase'" name="bid" type="number" min="0" oninput="validity.valid || (value = parseFloat(value));" class="bid" placeholder="text" />
                                </div>

                                <button :disabled="this.isDisabled || this.budgetErrorMEssage != null" @click="addItem()" style="margin-left: 4px;" class="addBtn">Add</button>
                                
                            </div>
                            <div v-if="(this.budgetErrorMEssage != null)" style="margin: unset; margin-bottom: 1%" class="errorContainer"> 
                                <div  class="errorHeading" ><img src="../assets/errorIcon.svg" style="width: 14px; height: 14px; margin-right: 8px"/> {{ this.budgetErrorMEssage }}</div>
                            </div>
                                <div v-if="match_type == 'Exact' && suggestedKeywords?.length>0" class="suggestionRowWrap">
                                    <div v-for="(item, index) in filteredSuggestions" :key="index" class="suggestionrows"> 
                                        <div class="rows targetingRow" style="justify-content: unset; padding: unset; width: 335px;" v-if="targeting" > 
                                            <div class="productId categoryClass" v-b-tooltip style="margin-right: 10px;" :title="item.keyWord">{{ item.keyWord }}</div>
                                            <select :disabled="this.isDisabled" class="match_type" v-model="item.selected">
                                                <option disabled :value="null" >Type</option>
                                                <option v-if="!title.includes('Keyword')">NA</option>
                                                <option v-if="title.includes('Keyword')">Exact</option>
                                                <option disabled v-if="title.includes('Keyword')">Phrase</option>
                                            </select>
                                            <div :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" class="productId categoryClass" style="min-width: 70px;max-width: 70px;text-align: left;padding-left: 15px;">{{ item.bid_price_suggestion }}</div>
                                            <div :style="campaignClass === 'Sponsored' ? '' : 'visibility: hidden'" style="margin-left: 20px;margin-right: 12px;" class="content"> 
                                                <img 
                                                    alt="img" 
                                                    class="currencyIcon" 
                                                    src="../assets/currencyIcon.svg"
                                                > 
                                                <input 
                                                    v-model="item.bid_price" 
                                                    :disabled="this.isDisabled" 
                                                    name="bid" 
                                                    type="number" min="0" oninput="validity.valid || (value = parseFloat(value));" 
                                                    class="bid"  
                                                    placeholder="text" 
                                                />
                                            </div>
                                            <button :disabled="this.isDisabled" @click="addItem({'keyword': item.keyWord, 'match_type': item.selected, 'bid': campaignClass === 'Privilege' ? this.campaignData.cpm : item.bid_price})" class="add">Add</button>
                                        </div>
                                    </div>
                                </div>
                            </tbody>

                            <div class="emptyCase" v-if="suggestedKeywords?.length===0 || match_type === 'Phrase'"> 
                                <img alt="img" src="../assets/emptyCase.svg">
                                <div class="emptyText">Add targetings for ad group</div>
                            </div>

                        </table>

                    </div> 
                    
                    <!-- Products -->

                    <div v-else-if="(!targeting && !showUploadComponent)"> 
                        <div class="secondRow"> 
                            <div class="search"> 
                                <input  :disabled="this.isDisabled" class="searchClass" v-model="search" type="text" placeholder="Search by product name">
                                <div class="searchBtn" v-if="!loading" @click="onSearchBtnClick(null, 'products')" :disabled="this.isDisabled" >Add</div>
                                <div v-else class="loader"></div>
                                <div class="searchText"></div>
                            </div>
                        </div>
                        <div class="list"> 
                            <div class="thirdRow"> 
                                <div class="text">Products</div>
                                <div v-if="this.selectedProducts?.length === 0 && this.productSearchResult?.length > 0 && !selectAllClicked" style="cursor: pointer" @click="onSelectAllProductsClick" class="text">Select all</div>
                                <div v-if="this.selectedProducts?.length > 0" @click="onRemoveAllProductsClick" style="cursor: pointer" class="text">Remove all</div>
                            </div>

                            <div class="emptyCase" v-if="productSearchResult?.length===0 ">
                                <img alt="img" src="../assets/emptyCase.svg">
                                <div class="emptyText">{{ this.emptyMessage }}</div>
                            </div>
                            <div class="productsList" v-else-if="productSearchResult?.length>0"> 
                                <div v-for="(item) in productSearchResult" :key="item">
                                    <div class="productWrapper"> 
                                        <div class="productDetailsWrapper"> 
                                            <img alt="img" class="itemImage" 
                                            :src="url + item?.imagePath ">
                                            <div class="productDetails"> 
                                                <div class="itemId"> 
                                                    <div class="tag">{{ item?.availableAt3pSeller ? '3P' : '1P' }}</div>
                                                    {{ item?.productId }}
                                                </div>
                                                <div class="itemName">{{ item?.name }}</div>
                                                <div v-if="item?.inStock" class="itemStockStatus"> In Stock </div>
                                            </div>
                                        </div>
                                        <input :disabled="this.isDisabled" type="checkbox" id="product" :value="item" class="checkbox" v-model="selectedProducts" :modelModifiers="{ deep: true }">
                                    </div>
                                </div>
                            </div>
                            
                        
                            <div class="pagination">
                                <div class="result">Result 1 of 1</div>
                                <div class="icons">
                                    <img alt="img" style="margin-right: 28px" src="../assets/chevron_left.svg"/>
                                    <img alt="img" src="../assets/chevron_right.svg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else> 
                        <UploadCsv 
                            @productIDArray="getProductIDArray" 
                            @keywordArray="getKeywordArray" 
                            @onFileUpload="onFileUpload" 
                            :uploadCsvType="this.selectionType" 
                            @uploadBtnclicked="onSearchBtnClick('csv')"
                            @updateLoader="onUpdateLoader"
                            :loadingForUpload="this.loadingForUpload"
                        ></UploadCsv>
                    </div>
                </div>
            </div>

            <div v-if="!targeting && selectedProducts?.length>0" class="selectedProductsSection"> 
                <div class="headerWrapper"> 
                    <div class="heading ">Selected products</div>
                    <div class="count">{{ selectedProducts?.length }} products added</div>
                </div>
                <div class="selectedProductsWrapper"> 
                    <div v-for="(item, index) in selectedProducts" :key="index">
                        <div class="productWrapper"> 
                            <div class="productDetailsWrapper"> 
                                <img  alt="img" class="itemImage" :src="url + item?.imagePath"  >
                                <div class="productDetails"> 
                                    <div class="itemId">
                                        <div class="tag">{{ item?.availableAt3pSeller ? '3P' : '1P' }}</div>
                                        {{ item.productId }}</div>
                                    <div class="itemName">{{ item.name }}</div>
                                <div v-if="item.inStock" class="itemStockStatus"> In Stock </div>
                                </div>
                            </div>
                            <img :disabled="this.isDisabled" @click="removeSelection(item,this.isDisabled)" alt="img" class="crossIcon" src="../assets/crossIcon.svg">
                        </div>
                    </div>
                </div>
            </div>

            <AddedSuggestedKeywords
                v-if="this.selectionType=='keywords' && match_type !== 'Broad'"
                :targeting="this.targeting"
                :addedSuggestedKeywords="this.addedCategories"
                @deleteFromAddedSuggestionsList="deleteFromAddedSuggestionsList"
                @deleteAll="deleteAllSelectedKeywords"
            />

        </div>
    </div>
</template>

<style scoped>

    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }

    .crossIcon{
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    .count{
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        color: #000000;
    }

    .selectedProductsSection{
        margin-left: 22px;
    }
    .itemStockStatus{
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.005em;
        color: #000000A6;
        text-transform: uppercase;
        margin-top: 6px;
    }

    .prices{
        display: flex;
        align-items: center;
    }

    .itemPrice{
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.005em;
        color: #141414;
        display: flex;
        align-items: center;
    }

    .itemMrp{
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.005em;
        text-decoration-line: line-through;
        color: rgba(0, 0, 0, 0.65);
        margin: 0 12px 0 8px;
        display: flex;
        align-items: center;
    }

    .itemDiscount{
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.005em;
        color: #E30513;
    }
    .productsList{
        padding: 16px 26px 16px 13px;
        height: 304px;
        overflow-y: scroll;
    }

    .wrapper{
        display: flex;
        /* justify-content: space-between; */
        align-items: flex-start;
    }

    .selectedProductsWrapper{
        width: 522px;
        height: 456px;
        overflow-y: scroll;
        background: #F8F8F8;
        border: 1px solid #D9D9D9;
        border-radius: 12px;
        padding: 14px 28px 14px 15px;
    }

    .selectedKeywordssWrapper{
        width: 522px;
        height: 504px;
        overflow-y: scroll;
        border: 1px solid #D9D9D9;
        border-radius: 12px;
    }

    .productWrapper{
        display: flex;
        justify-content: space-between;
        border: 1px solid #C4C4C4;
        border-radius: 8px;
        padding: 16px 13px;
        margin-bottom: 8px;
        background: #FFFFFF;
    }

    .productDetailsWrapper{
        display: flex;
    }

    .itemImage{
        margin-right: 16px;
        width: 116px;
        height: 116px;
    }

    .itemId{
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.005em;
        color: #141414;
        display: flex;
        font-family: "Inter-Regular";
        margin-bottom: 2px;
    }

    .tag{
        font-family: "Inter-Regular";
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: -0.005em;
        text-align: left;
        padding: 2px 10px;
        background: #DFDFFF;
        margin-right: 6px;
        border-radius: 4px;
        color: #000093;
    }

    .itemName{
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.005em;
        color: #141414;
        margin-bottom: 6px;
    }

    .itemPrice{
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.005em;
        color: #141414;
    }
    .activeClass{
        border-bottom: 3px solid #2E31BE;
    }

    .searchBtn{
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #FFFFFF;
        background: #2E31BE;
        border-radius: 4px;
        padding: 8px 22px;
        cursor: pointer;
    }

    .bid{
        width: 100%;
        padding-left: 4px;
        font-weight: 400;
        font-size: 12px;
        line-height: 21px;
        background: #FFFFFF;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        color: #414141;
    }

    .bidClass{
        border: 0.5px solid #B4B4B4;
        border-radius: 4px;
        padding: 0 8px 0 9px;
        max-width: 50px;
        min-width: 50px;
        display: flex;
        align-items: center;
    }

    .matchTypeClass{
        margin-left: 30px;
    }

    .categoryClass{
        min-width: 132px;
        max-width: 132px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .targetingRow{
        width: 100% !important;
    }

    .currency{
        height: 10px;
        margin-right: 8px;
    }

    .content{
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 75px;
        margin-right: 32px;
        border: 0.5px solid #B4B4B4;
        border-radius: 4px;
    }

    .searchClass{
        /* margin-right: 16px; */
        background: #FFFFFF;
        border: 1px solid #E4E5E6;
        border-radius: 4px;
        padding: 7px 16px;
        width: 305px;
        padding: 12px 16px 12px 30px;

    }
    ::-webkit-input-placeholder{
        margin-left: 50px !important;

    }
    .searchClass::placeholder{
        margin-left: 50px !important;
    }

    .currencyIcon{
        padding: 3px;
        color: #000000A6;
        opacity: 0.6;
    }

    .emptyCase{
        height: 290px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .emptyText{
        font-weight: 400;
        font-size: 12px;
        line-height: 21px;
        color: #4D4D4E;
    }

    .pagination{
        padding: 4px 24px 4px 24px;
        background: #F8F8F8;
        display: none;
        justify-content: space-between;
        align-items: center;
    }

    .result{
        font-weight: 400;
        font-size: 12px;
        line-height: 21px;
        color: #828282;
    }
    .info{
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.005em;
        color: #B4B4B4;
        padding-left: 20px;
        border-left: 3px solid #B4B4B4;
        max-width: 290px;
    }

    .firstRow{
        display: flex;
        border-bottom: 1px solid #E0E0E0;
        padding: 14px 0 0 22px;
        background: #F8F8F8;

    }

    .secondRow{
        padding: 18px 25px 14px 34px;
        display: flex;
        background: #F8F8F8;
    }

    .thirdRow{
        background: #EFEFEF;
        padding: 2px 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .suggested{
        background: #EFEFEF;
        width: 100%;
    }

    .fourthRow{
        padding: 12px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 0.8px solid #D9D9D9;
    }

    .rows{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px 0px 42px;
        border-bottom: 0.8px solid #D9D9D9;
        height: 40px;
    }

    .suggestionrows{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        border-bottom: 0.8px solid #D9D9D9;
        height: 40px;
        
    }

    .suggestionRowWrap{
        height: 352px;
        overflow-y: scroll;
    }

    .suggestionrows:nth-child(odd){
        background: #F8F8F8;
    }

    .rowWrapper{
        height: 285px;
        overflow-y: scroll;
    }

    .productId{
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        color: #000000A6;
    }

    .removeBtn{
        font-weight: 400;
        font-size: 12px;
        line-height: 21px;
        color: #BF0B0B;
        cursor: pointer;
        border: unset;
        background: unset;
        padding: unset;
    }

    .addBtn{
        background: #2E31BE;
        border-radius: 4px;
        font-weight: 700;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #FFFFFF;
        padding: 8px 20px;
        /* width: 24px; */
        cursor: pointer;
        border: unset;

    }
    .text{
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        color: #333333;
    }

    .remove{
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        color: #BF0B0B;
        cursor: pointer;
    }
    .row{
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        margin-right: 38px;
        cursor: pointer;
        padding-bottom: 8px;
    }

    .row:last-child{
        margin-right: unset;
    }

    .heading{
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #333333;
        /* margin-bottom: 12px; */
    }

    .headerWrapper{
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
    }
    .title{
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.01em;
        color: #666666;
        padding: 22px 0;
        padding-top: 0;
        border-bottom: 1px solid #E0E0E0;
        margin-bottom: 32px;
    }

    .table{
        border: 1px solid #E0E0E0;
        border-radius: 12px;
        max-width: 530px;
        min-width: 530px;
    }

    .search{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .searchIcon{
        position: absolute;
        left: 10px;
        top: 13px;
    }

    .targetSearch{
        display: flex;
        margin-right: 16px;
        background: #FFFFFF;
        border: 1px solid #E4E5E6;
        border-radius: 4px;
        padding: 7px 16px;
        width: 460px;

    }

    .productIdSearch{
        padding: 3px 16px;
    }

    .match_type{
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        display: flex;
        background: #FFFFFF;
        border: 1px solid #E4E5E6;
        border-radius: 4px;
        padding: 2px 4px;
        width: 60px;
        margin-right: 32px;
    }


    .searchText{
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        /* margin-left: 12px; */
        display: flex;
        /* margin-right: 16px; */
        background: #FFFFFF;
        border: unset;
        
    }
    .categorySearch{
        margin-left: unset;
        border: 1px solid #E4E5E6;
        border-radius: 4px;
        padding: 7px 0;
        padding-left: 8px;
        width: 132px;
        margin-right: 8px;
    }

    .matchTypeTitle{
        margin-left: 125px;
    }

    .tableRow{
        display: flex;
        /* justify-content: space-around; */
        padding: 0 30px 0px 24px;
        align-items: center;
        width: 100%;
    }

    .suggestedKeywords{
        width: 100%;
        /* background: #EFEFEF; */
        min-height: 381px;
    }

    .refresh{
        cursor: pointer;
        font-family: 'Inter-Regular';
        font-size: 12px;
        font-weight: 700;
        line-height: 19px;
        letter-spacing: 0em;
        text-align: center;
        color: #EB5757;
        padding: 5px 10px;
        border: 1px solid #EB5757;
        border-radius: 4px;
        display: flex;
        align-items: center;
    }

    .add{
        font-size: 12px;
        font-weight: 600;
        line-height: 15px;
        letter-spacing: 0em;
        text-align: center;
        color: #2E31BE;
        border: unset;
        background: unset;
        cursor: pointer;
        margin-left: 15px;
    }

    .refreshIcon{
        margin-right: 4px;
    }

    .headingWrapper{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }

    .loader {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 3px solid #ccc;
        border-top: 3px solid #007BFF;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }

    .errorContainer{
        background: #FDEDED;
        border-radius: 5px;
        margin: 1%;
        padding: 10px 14px;
    }

    .errorHeading{
        font-weight: 700;
        font-size: 12px;
        line-height: 140%;
        color: #EB5757;
        /* margin-bottom: 12px; */
        display: flex;
    }

    .checkboxClass{
        display: flex;
        align-items: center;
    }

    .textbox{
        font-family: "Inter-Regular";
        width: 100%;
        padding: 8px 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        /* color: #9B9B9B; */
        background: #FFFFFF;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        max-width: 246px;
    }
    .required::after {
        content: '*';
        color: #eb5757; 
        margin-left: 4px; 
        font-weight: bold;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>